import { render } from "./MeasurementsPage.vue?vue&type=template&id=e4da0136&ts=true"
import script from "./MeasurementsPage.vue?vue&type=script&lang=ts"
export * from "./MeasurementsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__